import { values } from './enums'

const _enum = {
  None: 0,
  Company: 1,
  Bank: 2,
  Blacklist: 4
}

export const associationTypes = {
  enumName: 'AssociationTypes',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/associationTypes.js